// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__5L3+U","white":"heading_white__ze+C0","dark-blue":"heading_dark-blue__vtOn-","yellow":"heading_yellow__qCUW5","black":"heading_black__QTzgf"};